import { render, staticRenderFns } from "./Badgebox.vue?vue&type=template&id=22b1296e&"
import script from "./Badgebox.vue?vue&type=script&lang=js&"
export * from "./Badgebox.vue?vue&type=script&lang=js&"
import style0 from "./Badgebox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports